import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e165ab16&scoped=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"
import style0 from "./detail.vue?vue&type=style&index=0&id=e165ab16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e165ab16",
  null
  
)

export default component.exports